<script setup lang="ts">
import InstallationLocationTableRow from '@/components/InstallationLocation/InstallationLocationTableRow.vue';
import type { InspectionPoint } from '@/models/inspectionPoint/InspectionPoint';
import { ref } from 'vue';
import { InspectionPointsLocation } from '@/composables/useInstallationLocationsTable';

const emits = defineEmits(['update-location']);

const installationLocations = defineModel<InspectionPoint[]>(
  'installationLocations',
  { default: [] }
);

const expanded = ref<string | undefined>(undefined);

const toggleExpand = (inspectionPointId: string | undefined) => {
  expanded.value =
    expanded.value === inspectionPointId ? undefined : inspectionPointId;
};

function handleUpdateLocation(
  index: number,
  updatedLocation: InspectionPointsLocation
) {
  emits('update-location', index, updatedLocation);
}
</script>

<template>
  <table
    class="min-w-full bg-light-2 dark:bg-dark-2 rounded-lg overflow-hidden"
    data-testid="installationLocationsTable"
  >
    <thead class="bg-light-2 dark:bg-dark-2 text-base">
      <tr>
        <th></th>
        <th class="py-3 px-4 text-left">Stockwerk</th>
        <th class="py-3 px-4 text-left">NE</th>
        <th class="py-3 px-4 text-left">SRT Funkempfang</th>
        <th class="py-3 px-4 text-left">Status</th>
        <th class="py-3 px-4 text-left">LTE-dbm</th>
        <th class="py-3 px-4 text-left">Auswahl</th>
      </tr>
    </thead>

    <tbody>
      <InstallationLocationTableRow
        v-for="(ip, index) in installationLocations"
        :key="ip.id"
        v-model:inspection-point-location="installationLocations[index]"
        :expanded="expanded"
        :index="index"
        @update:expanded="toggleExpand($event)"
        @update-location="handleUpdateLocation(index, $event)"
      />
    </tbody>
  </table>
</template>
